export class NotFoundController {
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./modules/xray/states/not_found_404/not_found.controller.js